import { computed, ref } from 'vue-demi';
import {
  IdentityIntactInfo
} from './const';
import { NativeMaterialInfo } from './../../../const/media';


export const initIdentity = (): Record<string, any> => ({
  identityInit: ref(false),
  identityList: ref([] as IdentityIntactInfo[]),
  curIdentity: ref({
    identity_type: 1,
  } as IdentityIntactInfo),
  displayName: ref(''),
  avatarIcon: ref({
    height: 100,
    url: '',
    web_uri: '',
    width: 100,
  }),
  localDisplayName: ref(''),
  localAvatarIcon: ref({
    height: 100,
    url: '',
    web_uri: '',
    width: 100
  }),
  nativeVideoList: ref([] as NativeMaterialInfo[]),
  nativeVideoCursor: ref(0),
  nativeVideoHasMore: ref(false),
  nativeVideoIdentityId: ref(''),
  useTikTokIdentity: ref(false)
});
export const state = {
  identity: initIdentity(),
};

export const getters = {
  identityFormData: computed(() => ({
    identityInit: state.identity.identityInit.value,
    identityList: state.identity.identityList.value,
    curIdentity: state.identity.curIdentity.value,
    nativeVideoCursor: state.identity.nativeVideoCursor.value,
    nativeVideoHasMore: state.identity.nativeVideoHasMore.value,
    nativeVideoIdentityId: state.identity.nativeVideoIdentityId.value,
    nativeVideoList: state.identity.nativeVideoList.value,
    displayName: state.identity.displayName.value,
    avatarIcon: state.identity.avatarIcon.value,
    localDisplayName: state.identity.localDisplayName.value,
    localAvatarIcon: state.identity.localAvatarIcon.value,
    useTikTokIdentity: state.identity.useTikTokIdentity.value
  }))
};
